module.exports = __webpack_public_path__ + "img/report.0f4998e3.png";